import React from "react";
import bonus from "../../components/turo.jpeg";

function Turo() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>How to get cars to put on TURO</h1>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default Turo;
